export default [{
    path: '/video',
    name: 'video',
    component: resolve => require(['../../view/video/video.vue'], resolve),
    meta: {
      navShow: true,
      keepAlive: true // 需要缓存
    },
  },
  {
    path: '/video_details',
    component: resolve => require(['../../view/video/video_detail/video_detail.vue'], resolve),
  },
  {
    path: '/video_special',
    component: resolve => require(['../../view/video/video_detail/subclass/video_special.vue'], resolve),
  },
  {
    path: '/hotmore',
    component: resolve => require(['../../view/video/subclass/more.vue'], resolve),
  },
  {
    path: '/av_actress',
    component: resolve => require(['../../view/video/subclass/av_actress.vue'], resolve),
  },
]



// WEBPACK FOOTER //
// ./src/router/video/index.js